import { render } from "./resources-create.vue?vue&type=template&id=7b91b5d2&scoped=true"
import script from "./resources-create.vue?vue&type=script&lang=js"
export * from "./resources-create.vue?vue&type=script&lang=js"

import "./resources-create.vue?vue&type=style&index=0&id=7b91b5d2&lang=scss&scoped=true"
import "./resources-create.vue?vue&type=style&index=1&id=7b91b5d2&lang=scss"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b91b5d2"]])

export default __exports__